import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-essor',
  templateUrl: './essor.component.html',
  styleUrls: ['./essor.component.scss']
})
export class EssorComponent  {

  constructor() { }

}
